import {
    TWCCL_END_DETAILS,
    TWCCL_INITIAL_DETAILS,
    TWCCL_INSTALLER_DETAILS
} from 'common/application.const/Licence/MyApplication/TWCCLApplication';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatTWCCLApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let installerDetails = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.WiringInstallerList && licenceDetails.WiringInstallerList.length > 0) {
        installerDetails = licenceDetails?.WiringInstallerList.map((value: any, i: number) => ({
            'wiring-installer-no': value?.WILicenceNo ?? '-',
            'wiring-installer-name': value?.WIName ?? '-',
            'status': value?.WILicenceStatus ?? '-'
        }));
    }

    licence = {
        id: 'telecommunication-wiring-contractor-class-licence',
        formID: 'telecommunication-wiring-contractor-class-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication-TELE' ? 'Application Details' : 'Licence Details',
        values: {
            [`${TWCCL_INITIAL_DETAILS}-service-provided`]: licenceDetails?.ServiceDetails?.ServicesProvidedDesc ?? '-',
            [`${TWCCL_INSTALLER_DETAILS}-list`]: installerDetails ?? [...installerDetails],
            [`${TWCCL_END_DETAILS}-proof-of-certificate`]: licenceDetails?.SupportingDocumentsAPImport?.ProofOfEmploymentDocName ?? '-',
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
            values: {
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.cancellationInformation?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: 'Application Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-telecommunication-wiring-contractor-class-licence',
            formID: 'amend-telecommunication-wiring-contractor-class-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication-TELE' ? 'Application Details' : 'Licence Details',
            values: {
                [`${TWCCL_INITIAL_DETAILS}-service-provided`]: licenceDetails?.ServiceDetails?.ServicesProvidedDesc ?? '-',
                [`${TWCCL_INSTALLER_DETAILS}-list`]: installerDetails ?? [...installerDetails],
                [`${TWCCL_END_DETAILS}-proof-of-certificate`]: licenceDetails?.SupportingDocumentsAPImport?.ProofOfEmploymentDocName ?? '-',

            }
        };
    }

    return licence;
};

const twcclPayloadApplication = {
    formatTWCCLApplication
};

export default twcclPayloadApplication;
